module.exports = __webpack_public_path__ + "static/media/mai-logo.98dbaf5a.png";